import { useEffect } from 'react';
import { useActivityState } from '@praktio/common-ui';
import { forwardActivity } from '../../utils/activityForwarder';

// Re-forward under the parent's idle window so a learner engaged inside the
// slide iframe (activity the parent's own detector can't see) keeps the
// parent-side connection ACTIVE, instead of the parent's idle heartbeat winning.
const FORWARD_INTERVAL_MS = 15000;

const PresenceForwarder = () => {
  const { state } = useActivityState();
  useEffect(() => {
    forwardActivity(state);
    const tick = setInterval(() => forwardActivity(state), FORWARD_INTERVAL_MS);
    return () => clearInterval(tick);
  }, [state]);
  return null;
};

export default PresenceForwarder;
